<template>
    <div class="container mb-3">
        <div class="row justify-content-md-center">
            <div class="col-md-8">
                <h1 v-if="headline">{{headline}}</h1>
                <div class="card">
                    <div class="card-body">
                        <slot/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['headline'],
        data() {
            return {}
        },
        created() {
        },
        methods: {}
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/layout/CenteredCard.vue